import { z } from 'zod'

export const channelSchema = z.enum(['EMAIL', 'WHATSAPP', 'DEAL', 'PHONE'])

export const ContactTypeSchema = z.enum(['CONTACT', 'PREBOOKING', 'PHONE'])

export type Channel = z.infer<typeof channelSchema>

export type ContactType = z.infer<typeof ContactTypeSchema>
